import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UniquePipe } from './unique.pipe';
import { CompanyNameFilterPipe } from './company-name-filter.pipe';
import { ProfileFilterPipe } from './profile-filter.pipe';
import { FourDotFiveDateFormatPipe } from './four-dot-five-date-format.pipe';
import { ContractDurationPipe } from './contract-duration';
import { FourDotFiveTimeStampFormatPipe } from './four-dot-five-time-stamp-format';
import { CategoryInHierarchyPipe } from './category-in-hierarchy';
import { TextSentenceCasePipe } from './text-sentence-case';
import { FIlterSkillsPipe } from './filter-skills.pipe';
import { CompanyNameSettingPipe } from './company-name-setting';
import { ConvertDurationInYearsPipe } from './convert-duration-in-years.pipe';
import { VendorFilterPipe } from './vendor-filter';
import { TruncatePipe } from './truncate';
import { ClientOrBuModifiedPipe } from './client-or-bu-modified.pipe';
import { CompanyNameSettingsFilterPipe } from './company-name-settings-filter.pipe';
import { DisplayOnMultiSelectPipe } from './display-on-multi-select.pipe';
import { DisplayOnSmallMultiSelectPipe } from './display-on-small-multi-select.pipe';
import { PhoneNumberFormatPipe } from './phone-number-format.pipe';
import { SingleDropdownSelectPipe } from './single-dropdown-select.pipe';
import { SubStringPipe } from './sub-string.pipe';
import { FourDotFiveTimeFormatPipe } from './four-dot-five-time-format.pipe';
import { ShowBannerMessagePipe } from './show-banner-message.pipe';

@NgModule({
  declarations: [
    UniquePipe,
    CompanyNameFilterPipe,
    ProfileFilterPipe,
    FourDotFiveDateFormatPipe,
    ContractDurationPipe,
    FourDotFiveTimeStampFormatPipe,
    CategoryInHierarchyPipe,
    TextSentenceCasePipe,
    FIlterSkillsPipe,
    CompanyNameSettingPipe,
    ConvertDurationInYearsPipe,
    VendorFilterPipe,
    TruncatePipe,
    ClientOrBuModifiedPipe,
    CompanyNameSettingsFilterPipe,
    DisplayOnMultiSelectPipe,
    DisplayOnSmallMultiSelectPipe,
    PhoneNumberFormatPipe,
    SingleDropdownSelectPipe,
    SubStringPipe,
    FourDotFiveTimeFormatPipe,
    ShowBannerMessagePipe
  ],
  imports: [
    CommonModule
  ],
  providers: [
    FourDotFiveTimeStampFormatPipe,
    FourDotFiveDateFormatPipe,
    CompanyNameSettingPipe,
    ConvertDurationInYearsPipe,
    DisplayOnMultiSelectPipe
  ],
  exports: [
    UniquePipe,
    CompanyNameFilterPipe,
    ProfileFilterPipe,
    FourDotFiveDateFormatPipe,
    ContractDurationPipe,
    FourDotFiveTimeStampFormatPipe,
    CategoryInHierarchyPipe,
    TextSentenceCasePipe,
    FIlterSkillsPipe,
    CompanyNameSettingPipe,
    ConvertDurationInYearsPipe,
    VendorFilterPipe,
    TruncatePipe,
    ClientOrBuModifiedPipe,
    CompanyNameSettingsFilterPipe,
    DisplayOnMultiSelectPipe,
    DisplayOnSmallMultiSelectPipe,
    PhoneNumberFormatPipe,
    SingleDropdownSelectPipe,
    SubStringPipe,
    FourDotFiveTimeFormatPipe,
    ShowBannerMessagePipe
  ]
})
export class PipesModule { }
